import FJLocalStore from '../../../../store/FJLocalStore';
import { SUITABLE_PHOTOS, UNSUITABLE_PHOTOS } from '../../../../config/dataConfig/FJHairstyleChangerDataConfig';
import FJImage from '../../../../common/components/FJImage/FJImage';
import FJConfig from '../../../../config/FJConfig';

import styles from './FJHairstyleDemonstration.module.less';
import PropTypes from 'prop-types';

function FJHairstyleDemonstration({ boxStyle = { width: '440px' } }) {
    return (
        <div className={styles.box} style={boxStyle}>
            <div className={styles.box_title}>{FJLocalStore._('photo-guidelines-for-best-results')}</div>
            <div className={styles.sub_title}>{FJLocalStore._('suitable-photos')}</div>
            <div className={styles.imgs_box}>
                {SUITABLE_PHOTOS.map(filename => (
                    <FJImage
                        key={filename}
                        imgSrc={FJConfig.hairstyleChangerCommonPath + filename + `?v=${FJConfig.version}`}
                        boxClassName={styles.img_item}
                    />
                ))}
            </div>
            <div className={styles.tip_content}>
                {FJLocalStore._(
                    'upload-a-clear-front-facing-photo-tie-or-slick-back-short-hair-let-long-hair-fall-naturally',
                )}
            </div>
            <div className={styles.sub_title}>{FJLocalStore._('unsuitable-photos')}</div>

            <div className={styles.imgs_box}>
                {UNSUITABLE_PHOTOS.map(filename => (
                    <FJImage
                        key={filename}
                        imgSrc={FJConfig.hairstyleChangerCommonPath + filename + `?v=${FJConfig.version}`}
                        boxClassName={styles.img_item}
                    />
                ))}
            </div>
            <div className={styles.tip_content}>
                {FJLocalStore._('avoid-side-views-dark-lighting-covered-faces-group-shots-or-cartoon-images')}
            </div>
        </div>
    );
}

FJHairstyleDemonstration.propTypes = {
    boxStyle: PropTypes.object,
};

export default FJHairstyleDemonstration;
